import { RecordUtils } from "@rsm-hcd/javascript-core";
import ShareSpaceItem from "models/interfaces/share-spaces/share-space-item";
import PublicationRecord from "../publication-record";
import SectionRecord from "../section-record";
import { CollectionUtils } from "utilities/collection-utils";

// -----------------------------------------------------------------------------------------
// #region Constants
// -----------------------------------------------------------------------------------------

import { Record } from "immutable";
const defaultValues: ShareSpaceItem =
    RecordUtils.auditableDefaultValuesFactory<ShareSpaceItem>({
        shareSpaceId: undefined,
        sectionId: undefined,
        externalId: undefined,
        code: undefined,
        edition: undefined,
        shareSpace: undefined,
        section: undefined,
        subSections: [],
        publication: undefined,
        displaySequence: 0,
    });

// #endregion Constants

export default class ShareSpaceItemRecord
    extends Record(defaultValues)
    implements ShareSpaceItem
{
    // -----------------------------------------------------------------------------------------
    // #region Constructor
    // -----------------------------------------------------------------------------------------

    constructor(params?: ShareSpaceItem) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }
        if (params.publication != null) {
            params.publication = RecordUtils.ensureRecord(
                params.publication,
                PublicationRecord
            );
        }

        if (params.section != null) {
            params.section = RecordUtils.ensureRecord(
                params.section,
                SectionRecord
            );
        }

        if (CollectionUtils.hasValues(params.subSections)) {
            params.subSections = params.subSections?.map(
                (subSection: SectionRecord) =>
                    RecordUtils.ensureRecord(subSection, SectionRecord)
            );
        }

        super(params);
    }

    // #endregion Constructor

    // #region Public Methods
    /**
     * Merges new values into the record and returns a new instance.
     *
     * @param {Partial<ShareSpace>} values
     */
    public with(values: Partial<ShareSpaceItemRecord>): ShareSpaceItemRecord {
        return new ShareSpaceItemRecord(Object.assign(this.toJS(), values));
    }

    /**
     * Prepares the Share Space Item record for update.
     * At a minimum, it should remove navigation props.
     *
     * @param {Partial<ShareSpace>} values
     */
    public prepareForUpdate(): ShareSpaceItemRecord {
        // At a minimum, we want to remove nav props.
        // Original Problem:
        //      AWS Cross-Site Scripting was blocking the request and resulting in a 403.
        //      This was because we were including the section/subsection xml body.
        //  We are not updating that information, nor do we want to accidentally overwrite it.
        return this.with({
            section: undefined,
            subSections: [],
            publication: undefined,
        });
    }

    // #endredion Public Methods
}
